import { Component, OnInit } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';
import { EmpresaService } from 'src/app/admihair/service/empresa.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MensagemChamado } from 'src/app/admihair/api/dto/mensagem-chamado';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { ArquivoAnexo } from 'src/app/admihair/api/file/arquivo-anexo';
import { ChamadoSuporteRequest } from 'src/app/admihair/api/dto/chamado-suporte-request';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';

@Component({
  selector: 'app-chamado-franquia-encerrar',
  templateUrl: './chamado-franquia-encerrar.component.html',
  styleUrls: ['./chamado-franquia-encerrar.component.scss']
})
export class ChamadoFranquiaEncerrarComponent extends AdmihairBaseComponent implements OnInit {

  textContent: string = '';
  listaMensagensChamado: MensagemChamado[] = [];
  textoDescricaoChamado: string = '';

  chamadoSelecionado?: ChamadoSuporte;
  adicionadoBaseConhecimento?: boolean;

  progressoRequisicao: boolean = false;
  exibirRedirecionarEncerrado: boolean = false;

  arquivosProcessando: number = 0;
  arquivosAnexados: ArquivoAnexo[] = [];
  maxFileSizeMB = 5;
  validTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv'
  ];

  constructor(private chamadoSuporteService: ChamadoSuporteService,
    private empresaService: EmpresaService,
    private sanitizer: DomSanitizer,
    erroService: ErroService,
    storageService: UtilStorageService,
    router?: Router,
    activatedRoute?: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.buscarChamado();
  }

  buscarChamado() {
    this.chamadoSuporteService.buscarPorId(this.idParametroUrl).subscribe({
      next: (data: ChamadoSuporte) => {
        this.chamadoSelecionado = data;
        this.adicionadoBaseConhecimento = data.adicionaBaseConhecimento ?? false;
        this.setExibirSpinnerPrincipal(false);
      }
      , error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    });
  }

  encerrarChamado() {
    this.progressoRequisicao = true;
    const descricaoChamado: MensagemChamado = {
      conteudo: this.textoDescricaoChamado,
      tipoMensagem: 'TEXTO',
      usuario: this.getUsuarioLogadoSistema(),
      categoria: 'FECHAMENTO'
    }
    this.listaMensagensChamado.unshift(descricaoChamado);

    const chamadoSuporteRequest: ChamadoSuporteRequest = {
      id: this.chamadoSelecionado?.id,
      administradora: this.getAdministradora(),
      empresa: this.chamadoSelecionado?.empresa,
      usuarioFechamento: this.getUsuarioLogadoSistema(),
      status: 'ENCERRADO',
      adicionaBaseConhecimento: this.adicionadoBaseConhecimento,
      listaMensagens: this.listaMensagensChamado
    }
  
    this.chamadoSuporteService.encerrar(chamadoSuporteRequest).subscribe({
      next: () => {
        this.progressoRequisicao = false;
        this.exibirRedirecionarEncerrado = true;
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  redirecionarChamadoEncerrado() {
    this.redirecionarPagina('/rfarias/suporte/chat/' + this.chamadoSelecionado?.id);
  }

  onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (!items) return;

    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          const validacao = this.validarArquivo(file);
          if (validacao.valido) {
            this.addFile(file);
          } else {
            this.exibirMensagemErroArquivo(validacao.mensagemErro);
          }
        }

      }
    }
  }

  onFileSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      Array.from(target.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
      target.value = '';
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      Array.from(event.dataTransfer.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  addFile(file: File) {
    this.arquivosProcessando++;

    const tipoArquivo = this.obterTipoArquivo(file);
    const nomeArquivo = file.name;

    this.fileToBase64(file).then(base64 => {
      const mensagem: MensagemChamado = {
        conteudo: base64,
        usuario: this.getUsuarioLogadoSistema(),
        tipoMensagem: tipoArquivo,
        categoria: 'FECHAMENTO',
        nomeArquivo: file.name
      };

      this.listaMensagensChamado.push(mensagem);

      const isImagem = tipoArquivo === 'IMAGEM';

      this.arquivosAnexados.push(
        {
          preview: isImagem ? this.sanitizer
            .bypassSecurityTrustUrl(URL.createObjectURL(file)) : undefined,
          mensagem: mensagem,
          nome: nomeArquivo,
          icone: !isImagem ? this.obterIconeArquivo(tipoArquivo) : undefined
        }
      )

    }).catch(error => {
      console.error('Erro ao processar arquivo:', error);
    }).finally(() => {
      this.arquivosProcessando--;
    });
  }

  removerArquivo(index: number) {
    const arquivo = this.arquivosAnexados[index];
    const i = this.listaMensagensChamado.indexOf(arquivo.mensagem);
    if (i >= 0) {
      this.listaMensagensChamado.splice(i, 1);
    }
    this.arquivosAnexados.splice(index, 1);
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  isValidFile(file: File): boolean {
    const isTypeValid = this.validTypes.includes(file.type);
    const isSizeValid = file.size <= this.maxFileSizeMB * 1024 * 1024;
    return isTypeValid && isSizeValid;
  }

  validarArquivo(file: File): { valido: boolean, mensagemErro?: string } {
    const tamanhoMaximoBytes = this.maxFileSizeMB * 1024 * 1024;

    const extensao = file.name.split('.').pop()?.toUpperCase() || 'DESCONHECIDO';

    if (!this.validTypes.includes(file.type)) {
      return {
        valido: false,
        mensagemErro: `Tipo de arquivo "${extensao}" não é permitido. Aceitamos imagens, PDF, DOCX e CSV.`
      };
    }

    if (file.size > tamanhoMaximoBytes) {
      return {
        valido: false,
        mensagemErro: `O arquivo "${file.name}" excede o tamanho máximo permitido de ${this.maxFileSizeMB}MB.`
      };
    }

    return { valido: true };
  }

  exibirMensagemErroArquivo(error?: string) {
    this.messages = [{
      severity: 'warn', summary: 'Anexo inválido:',
      detail: error ? error : 'Erro ao anexar'
    }];
    this.messagemVisivel = true;
  }

  private obterTipoArquivo(file: File): string {
    const tipoMime = file.type;
    const extensao = file.name.split('.').pop()?.toLowerCase() || '';

    if (tipoMime.startsWith('image/')) {
      return 'IMAGEM';
    }

    switch (extensao) {
      case 'pdf':
        return 'PDF';
      case 'csv':
        return 'CSV';
      case 'docx':
        return 'DOCX';
      default:
        return 'DOCUMENTO';
    }
  }

  obterIconeArquivo(tipo: string) {
    switch (tipo) {
      case 'IMAGEM':
        return 'pi pi-image';
      case 'PDF':
        return 'pi pi-file-pdf';
      case 'CSV':
        return 'pi pi-file-excel';
      case 'DOCX':
        return 'pi pi-file';
      default:
        return 'pi pi-file';
    }
  }

}
